import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  MAX_ITEMS_IN_PAGE,
  setIsSaving,
} from "../commonActions";
import qs from "qs";
import { DRAFT } from "../posts/postsActions";

const FETCH_SPLASH_SCREENS = "FETCH_SPLASH_SCREENS";
const SET_SPLASH_SCREEN_FIELD_CHANGE = "SET_SPLASH_SCREEN_FIELD_CHANGE";
const SET_SPLASH_SCREEN = "SET_SPLASH_SCREEN";
const RESET_SPLASH_SCREEN = "RESET_SPLASH_SCREEN";
const SPLASH_SCREEN_FILTER = "SPLASH_SCREEN_FILTER";

export const SET_SPLASH_SCREENS_PAGINATION = "SET_SPLASH_SCREENS_PAGINATION";
export const RESET_SPLASH_SCREENS_PAGINATION =
  "RESET_SPLASH_SCREENS_PAGINATION";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};
export const fetchSplashScreens = (filters = null) => {
  return (dispatch, getState) => {
    client()
      .get("splash-screen/list", {
        params: {
          filters,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let splashscreens = result.data;
          if (!splashscreens.length) {
            splashscreens = null;
          } else {
            let numItems = splashscreens.length;
            let min = getState().splashscreens.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE
                ? numItems
                : getState().splashscreens.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_SPLASH_SCREENS_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }

          dispatch({ type: FETCH_SPLASH_SCREENS, splashscreens });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const handleInputChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {};
    if (!e && definedValue) {
      value = definedValue;
    } else {
      const id = e.target.id;

      value = {
        [id]: e.target.value,
      };
    }

    dispatch({ type: SET_SPLASH_SCREEN_FIELD_CHANGE, value });
  };
};

export const getSplashScreen = (id) => {
  return (dispatch) => {
    client()
      .get("splash-screen/get", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let splashscreen = result.data;
          dispatch({ type: SET_SPLASH_SCREEN, splashscreen });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const upsertSplashScreen = (callback = null) => {
  return (dispatch, getState) => {
    dispatch(setIsSaving(true));

    const clientObj = getState().splashscreens.splashscreen;
    clientObj.label = clientObj?.label || "";
    clientObj.description = clientObj.description || "";
    clientObj.sequence = clientObj?.sequence || 0;
    clientObj.status = clientObj?.status?.id || clientObj?.status || DRAFT;
    clientObj.image = clientObj?.image || "";
    delete clientObj.updated_at;
    delete clientObj.updated_by;
    delete clientObj.created_at;
    delete clientObj.created_by;

    let endpoint = "splash-screen/cms/create";
    let message = "SplashScreen has been successfully created.";

    if (clientObj.id) {
      endpoint = "splash-screen/cms/update";
      message = "SplashScreen has been successfully updated.";
    }

    client()
      .post(endpoint, clientObj)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
          if (!clientObj.id) {
            const value = { id: result.data };
            dispatch({ type: SET_SPLASH_SCREEN_FIELD_CHANGE, value });
          }
        }
      })
      .finally(() => {
        dispatch(setIsSaving(false));
        window.location.replace("/#/splash-screens");
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetSplashScreen = () => {
  return (dispatch) => {
    dispatch({ type: RESET_SPLASH_SCREEN });
  };
};

export const filterSplashScreens = (filter) => {
  return (dispatch) => {
    dispatch({ type: SPLASH_SCREEN_FILTER, filter });
  };
};
